'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

// components
import { ModalStepper } from 'dumb';

// batch view
import MarketOvertimeRulesBatchStepList from './components/marketOvertimeRulesBatchStepList';

// phrases
import phrases from '../../marketOvertimeRules.phrases';

class MarketOvertimeRulesModalBatch extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loadingModal: false,
		};
	}

	_batchSubmit() {
		const { batchList, handleClose, addMarketOvertimeRule } = this.props;

		this.setState(() => ({
			loadingModal: true,
		}));

		const payload = batchList.map((entry) => {
			return {
				...(entry?.market?.value && {
					market: entry.market.value,
				}),
				...(entry?.second_unit?.value && {
					second_unit: entry.second_unit.value,
				}),
				...(entry?.type?.value && {
					type: entry.type.value,
				}),
				...(entry?.unit?.value && {
					unit: entry.unit.value,
				}),

				...(entry?.from && {
					active: {
						from: entry?.from,
						...(entry?.to && {
							to: entry.to,
						}),
					},
				}),

				...(entry?.amount && {
					amount: entry.amount,
				}),
				...(entry?.second_amount && {
					second_amount: entry.second_amount,
				}),
			};
		});

		addMarketOvertimeRule({ batch: payload })
			.then(() => handleClose())
			.finally(() =>
				this.setState(() => ({
					loadingModal: false,
				}))
			);
	}

	render() {
		const {
			modalVisible,
			handleClose,
			batchList,
			editBatchListItem,
			removeBatchListItem,
			addBatchListItemRow,
		} = this.props;

		const steps = [
			{
				component: (
					<MarketOvertimeRulesBatchStepList
						batchList={batchList}
						editBatchListItem={editBatchListItem}
						removeBatchListItem={removeBatchListItem}
						productRecommendationUrl={this.productRecommendationUrl}
						tileLayoutUrl={this.tileLayoutUrl}
						ingredientConfigurationUrl={this.ingredientConfigurationUrl}
						addBatchListItemRow={addBatchListItemRow}
					/>
				),
				title: phrases.MODAL_BATCH_STEP_LIST_TITLE,
				isValid: !!batchList?.length,
				onNext: () => this._batchSubmit(),
				loading: this.state.loadingModal,
				confirmButtonLabel: phrases.MODAL_BATCH_STEP_LIST_CONFIRM_BUTTON_LABEL,
				defaultStyles: false,
				noScroll: false,
			},
		];

		return modalVisible ? (
			<ModalStepper
				isOpen={modalVisible}
				steps={steps}
				showStep={false}
				onClose={handleClose}
			/>
		) : null;
	}
}

MarketOvertimeRulesModalBatch.propTypes = {
	modalVisible: PropTypes.bool,
	handleClose: PropTypes.func,
	batchList: PropTypes.array,
	editBatchListItem: PropTypes.func,
	removeBatchListItem: PropTypes.func,
	addBatchListItemRow: PropTypes.func,
	addMarketOvertimeRule: PropTypes.func,
};

export default MarketOvertimeRulesModalBatch;
